import { Button } from 'antd';
import styled from 'styled-components';

export const DetailsHeaderActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 12px 20px;
  max-width: 100%;

  @media (max-width: 991px) {
    width: 100%;
    justify-content: space-between;
  }
`;

export const DetailsHeaderActionGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

export const DetailsHeaderEditActions = styled(DetailsHeaderActionGroup)`
  flex-wrap: nowrap;
  flex-shrink: 0;
  margin-left: auto;
`;

export const DetailsHeaderButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 36px;
  padding: 0 12px;
  border-radius: 6px;
  border-color: #dce4ed;
  color: #183955;
  font-size: 14px;
  box-shadow: none;
  white-space: nowrap;

  > span {
    display: inline-flex;
    align-items: center;
  }
  .ant-btn-icon {
    margin: 0;
  }

  &:hover:not(:disabled) {
    color: #183955;
    border-color: #93aac0;
    background: #f0f6fc;
  }

  &.ant-btn-primary {
    color: white;
    background: #183955;
    border-color: #183955;
    &:hover:not(:disabled) {
      color: white;
      background: #244864;
      border-color: #244864;
    }
  }

  &.ant-btn-dangerous {
    color: #9f3840;
    background: transparent;
    border-color: transparent;
    &:hover:not(:disabled) {
      color: #9f3840;
      background: #fff1f0;
      border-color: #f2d3d5;
    }
  }

  &:disabled {
    color: #94a3b8;
    background: #f1f5f9;
    border-color: #e2e8f0;
  }
`;
